export default __webpack_public_path__ + "static/media/1.88b7dee9.webp";